import React, {Component} from 'react';
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap/lib/Modal';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import Button from 'react-bootstrap/lib/Button';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import FormControl from 'react-bootstrap/lib/FormControl';
import HelpBlock from 'react-bootstrap/lib/HelpBlock';

import { closeInstagramEmailModal, updateField } from '../actions/instagramEmail.js'
import { instagramRegister } from '../actions/auth.js'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import config from '../config.js'

class InstagramEmail extends Component {

	static defaultProps = {}

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

	updateField(event) {
		const { dispatch } = this.props
		dispatch(updateField(event.target.name, event.target.value))
	}

	closeInstagramEmailModal() {
		const { dispatch } = this.props
		dispatch(closeInstagramEmailModal())
	}

	login() {
		const { dispatch } = this.props
		dispatch(closeInstagramEmailModal())

		dispatch(instagramRegister(this.props.info.email, this.props.token, window.location.origin))
	}

	render() {
		return (
			<div style={{ height: 120, width: 200}}>
				<Modal
					keyboard={false}
					backdrop="static"
					show={this.props.showInstagramEmailModal}
					onHide={this.closeInstagramEmailModal.bind(this)}>
					<Modal.Header>
          </Modal.Header>
			    <Modal.Body>
						<div class="text-center">
							<p>Please give us your email, we would like to verify your access.</p>
							<br/><br/>
						</div>
						<form>
							<FormGroup>
								<FormControl
									type="text"
									name="email"
									value={this.props.info.email}
									placeholder="Enter your email here"
									onChange={this.updateField.bind(this)}
								/>
								<FormControl.Feedback />
								<HelpBlock></HelpBlock>

							</FormGroup>
						</form>
					</Modal.Body>
			    <Modal.Footer>
						<Button bsStyle="primary" block onClick={this.login.bind(this)}>Login</Button>
						<ControlLabel>{this.props.error}</ControlLabel>
					</Modal.Footer>
			  </Modal>
			</div>
		)
	}
}
const mapStateToProps = state => {
  return state.instagramEmailReducer
}

export default withRouter(
  connect(mapStateToProps)(InstagramEmail)
);



// WEBPACK FOOTER //
// ./src/components/InstagramEmail.js